import React, { useEffect, useRef, useState } from "react";
import FullPage from "../elements/fullPage/fullPage.jsx";
import { useIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import {
  NEWS,
  setCurrentAppOverlay,
  setCurrentFeature,
  setPage,
} from "../../reduxStore/actions/main";
import { includeText } from "../search/search.jsx";
import Highlight from "../elements/text/highlight.text.jsx";
import StandardHeadline from "../elements/text/standardHeadline.text.jsx";
import NewsEventCard, {
  getInfoPills,
} from "../elements/cards/newsEventCard.jsx";
import { AppOverlayIFrame } from "../../functions/classes/miscelleanous.classes.js";
import moment from "moment";
import { SkeletonPost } from "../elements/loading/NewsSkeleton.jsx";
import { urlPostId } from "../nativeAppInterface/sideEffects/usePushNotificationActions.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { statisticLogger } from "../statisticLogger/StatisticLogger.container.js";
import { pageNames } from "../../reduxStore/reducers/main.js";

function News(props) {
  const [searchText, setSearchText] = useState("");
  const [visibleNews, setVisibleNews] = useState([]);
  const [pinnedNews, setPinnedNews] = useState([]);
  const [newsLoaded, setNewsLoaded] = useState(false);

  const isFuzzy = useRef();
  const intl = useIntl();

  const handleReadMore = (item) => {
    if (item) {
      statisticLogger.addLog({
        action: {
          group: "NewsList",
          movement: "stay",
          id: "clickonNewsArticleFromNews",
          name: "Click on news article 'Read more'",
          type: "click",
          interaction: "select",
          content: {
            globalPoiIds: [item.globalPoiId],
            globalPoiId: item.globalPoiId,
            globalName: item.name,
            campusId: item.campusId,
            category: item.category,
          },
        },
      });
    }
    props.setCurrentAppOverlay(
      new AppOverlayIFrame("News", item.website, { contentType: "news" })
    );
  };

  const getRelevantNews = (fuzzy) => {
    isFuzzy.current = fuzzy;
    let filteredNews = NEWS.filter((news) => {
      return (
        !news.additionalData?.isPinned &&
        ("" === searchText || includeText(news, fuzzy, searchText))
      );
    }).map((news) => {
      return {
        ...news,
        name: news.name.toLowerCase().includes(searchText.toLowerCase())
          ? news.name
          : `${news.name} (${news.includesSearchString(searchText)})`.replace(
              "(undefined)",
              ""
            ), //wenn die fuzzysearch anschlägt. anonsten hätte hier noch eine prüfung hingemusst und das wollte ich dem code nicht antun.
      };
    });
    filteredNews.sort((a, b) => {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return moment(b.datetime) - moment(a.datetime);
    });

    return filteredNews;
  };

  const getPinnedNews = () => {
    return NEWS.filter((n) => n.additionalData?.isPinned);
  };

  const prepareNews = () => {
    if (!props.serverDataLoaded) {
      return;
    }
    setPinnedNews(getPinnedNews());
    setVisibleNews(getRelevantNews(false));

    if (!visibleNews.length) {
      setVisibleNews(getRelevantNews(true));
    }
    props.setPage(pageNames.news);
    statisticLogger.currentPage = pageNames.news;
    statisticLogger.addLog({
      action: {
        id: "enterNewsPage",
        name: "Enter News Page",
        group: "Page",
        movement: "enter",
        type: "click",
      },
    });
    setNewsLoaded(true);
  };

  useEffect(prepareNews, [props.serverDataLoaded]);

  useEffect(() => {
    setVisibleNews(getRelevantNews(true));
  }, [searchText, NEWS]);

  if (!NEWS.length && newsLoaded) {
    return (
      <FullPage
        title={intl.formatMessage({ id: "news.title" })}
        searchText={searchText}
        setSearchText={setSearchText}
        searchCategory="news"
        outerClassName={"fullPage--news"}
        headerClassName={"fullPage__header--news"}
        innerContainerClassName="fullPage__content--news"
      >
        <div className={"d-flex flex-column align-items-center"}>
          <StandardHeadline
            type={"h1"}
            text={<FormattedMessage id="news.empty" />}
            className={"text-center m-5 mb-4"}
          />
          <FontAwesomeIcon
            style={{ fontSize: "4rem" }}
            icon={["fal", "megaphone"]}
          />
        </div>
      </FullPage>
    );
  }

  if (!visibleNews.length && newsLoaded) {
    return (
      <FullPage
        title={intl.formatMessage({ id: "news.title" })}
        searchText={searchText}
        setSearchText={setSearchText}
        searchCategory="news"
        outerClassName={"fullPage--news"}
        headerClassName={"fullPage__header--news"}
        innerContainerClassName="fullPage__content--news"
      >
        <StandardHeadline
          className={"text-center mt-5"}
          text={<FormattedMessage id="news.noResults" />}
          type={"h1"}
        />
      </FullPage>
    );
  }

  return (
    <FullPage
      title={intl.formatMessage({ id: "news.title" })}
      searchText={searchText}
      setSearchText={setSearchText}
      headlineClassName={"standardHeadline__news"}
      searchCategory="news"
      outerClassName={"fullPage--news"}
      headerClassName={"fullPage__header--news"}
      innerContainerClassName="fullPage__content--news"
    >
      <div
        className={`d-flex flex-wrap justify-content-center mt-3 w-100`}
        style={{ paddingBottom: window.innerHeight / 3 }}
      >
        {newsLoaded ? (
          <>
            <div
              className={"mb-3 d-flex flex-wrap justify-content-center w-100"}
            >
              {pinnedNews.map((item, i) => {
                let pills = getInfoPills(
                  item,
                  props.setCurrentFeature,
                  props.history.push
                );

                return (
                  <NewsEventCard
                    pinned
                    showTime={false}
                    onClick={item.website ? () => handleReadMore(item) : null}
                    key={item.id}
                    datetime={item.datetime}
                    standardCardClassName={"mr-3 ml-3 mb-3 col-sm-12 col-md-4"}
                    headline={
                      <Highlight search={searchText}>{item.name}</Highlight>
                    }
                    backgroundUrl={item.titleImageUrl}
                    contentText={item.description}
                    infoPills={pills}
                  />
                );
              })}
            </div>
            {visibleNews.map((newsItem) => {
              let pills = getInfoPills(
                newsItem,
                props.setCurrentFeature,
                props.history
              );

              return (
                <NewsEventCard
                  scrollTo={newsItem.id === props.notificationPostId}
                  onClick={
                    newsItem.website ? () => handleReadMore(newsItem) : null
                  }
                  key={newsItem._id}
                  showTime={false}
                  datetime={newsItem.datetime}
                  standardCardClassName={
                    "mr-3 ml-3 mb-3 col-sm-12 col-md-4 standardCard__news"
                  }
                  headline={
                    <Highlight search={searchText}>{newsItem.name}</Highlight>
                  }
                  backgroundUrl={newsItem.titleImageUrl}
                  contentText={newsItem.description}
                  infoPills={pills}
                />
              );
            })}
          </>
        ) : (
          <SkeletonPost length={3} linesLength={2} />
        )}
      </div>
    </FullPage>
  );
}

export function useShowNotificationCard(location) {
  const [notificationPostId, setNotificationPostId] = useState(null);
  const getNotificationPostId = () => {
    if (!location) {
      console.error("Kein location object in useShowNotificationCard");
      return;
    }
    const queryString = location.search;
    const urlParams = new URLSearchParams(queryString);
    const postId = +urlParams.get(urlPostId);

    if (postId != null && !Number.isNaN(postId)) {
      setNotificationPostId(postId);
    }
  };

  useEffect(() => {
    getNotificationPostId();
  }, []);

  return notificationPostId;
}
const mapDispatchToProps = (dispatch) => ({
  setCurrentAppOverlay: (overlay) => dispatch(setCurrentAppOverlay(overlay)),
  setCurrentFeature: (poi) => dispatch(setCurrentFeature(poi)),
  setPage: (page) => dispatch(setPage(page)),
});

const mapPropsToState = (state) => ({
  notificationPostId: state.main.notificationPostId,
  serverDataLoaded: state.main.serverDataLoaded,
  isApp: state.main.isApp,
  isTerminal: state.main.isTerminal,
});
export default connect(mapPropsToState, mapDispatchToProps)(News);
